const state = {
    singleChartSelected: {
    },
    singleChartOptions: [
        {
            text: "",
            value: {
                name: "",
                data: {
                    senTime: [],
                    senData: {
                        bar: {},
                        line: {
                            name: "",
                            data: [],
                            color: "#FF3300",
                        },
                        unit: "",
                    },
                    senType: "VerticalBarLine",
                },
            },
        },
        {
            text: "",
            value: {
                name: "",
                data: {
                    senTime: [],
                    senData: {
                        bar: {},
                        line: {
                            name: "",
                            data: [],
                            color: "#FF3300",
                        },
                        unit: "",
                    },
                    senType: "VerticalBarLine",
                },
            },
        },
    ],
    singleChartDetail: {
        chartId: "",
        chartName: "",
        styleGroup: { width: '100%', height: '250px' }
    }
}
const getters = {
    get_singleChartSelected: state => {
        return state.singleChartSelected
    },
    get_singleChartOptions: state => {
        return state.singleChartOptions
    },
    get_singleChartDetail: state => {
        return state.singleChartDetail
    }
}
const actions = {
    set_singleChartSelected(context, obj) {
        context.commit('SET_SINGLECHARTSELECTED', obj);
    },
    set_singleChartOptions(context, array) {
        context.commit('SET_SINGLECHARTOPTIONS', array);
    },
    set_singleChartOptionsData(context, array) {
        context.commit('SET_SINGLECHARTOPTIONSDATA', array);
    },
    set_singleChartName(context, obj) {
        context.commit('SET_SINGLECHARTNAME', obj);
    },
    set_singleChartStyle(context, obj) {
        context.commit('SET_SINGLECHARTSTYLE', obj);
    },
    clear_singleChart(context) {
        context.commit('CLEAR_SINGLECHART');
    }
}
const mutations = {
    SET_SINGLECHARTSELECTED(state, obj) {
        state.singleChartSelected = obj;
    },
    SET_SINGLECHARTOPTIONS(state, array) {
        state.singleChartOptions = array;
    },
    SET_SINGLECHARTOPTIONSDATA(state, array) {
        if (array.length == state.singleChartOptions.length) {
            for (let i = 0; i < array.length; i++) {
                state.singleChartOptions[i].value.data.senTime = array[i].senTime;
                state.singleChartOptions[i].value.data.senData.bar = array[i].senData.bar;

            }
        } else {
            console.log('SET_SINGLECHARTOPTIONSDATA data length erro');
        }
    },
    SET_SINGLECHARTNAME(state, obj) {
        state.singleChartDetail.chartId = obj.chartId;
        state.singleChartDetail.chartName = obj.chartName;

    },
    SET_SINGLECHARTSTYLE(state, obj) {
        state.singleChartDetail.styleGroup = obj;
    },
    CLEAR_SINGLECHART(state) {
        state.singleChartSelected = {};
        state.singleChartOptions = [];
        state.singleChartSelected = {
            chartId: "",
            chartName: "",
            styleGroup: { width: '100%', height: '250px' }
        };
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/singleChart.js